import moment from 'moment'

import { PropOptionSelect } from '@/models'
import { createRangeYears } from '@/utils/dateLibs'

const yearMin = 2021

export const dateToday = moment(new Date()).toDate()
export const currentYear = dateToday.getFullYear()
export const currentMonth = dateToday.getMonth() + 1

export const monthOptions: PropOptionSelect[] = [
  { text: 'Enero', value: 1 },
  { text: 'Febrero', value: 2 },
  { text: 'Marzo', value: 3 },
  { text: 'Abril', value: 4 },
  { text: 'Mayo', value: 5 },
  { text: 'Junio', value: 6 },
  { text: 'Julio', value: 7 },
  { text: 'Agosto', value: 8 },
  { text: 'Septiembre', value: 9 },
  { text: 'Octubre', value: 10 },
  { text: 'Noviembre', value: 11 },
  { text: 'Diciembre', value: 12 }
]

export const rangeYearsDefault: number[] = createRangeYears(yearMin, currentYear).map(yearOp => Number(yearOp.value))
